import { turnstile } from "./turnstile.js";

const RESPONSE_TIMEOUT = 10000;
const GENERIC_ERROR = "Something went wrong. Please try again later.";

export function newsletter() {
  return {
    ...turnstile("newsletter-signup"),

    init() {
      this.initTurnstile();
    },

    email: "",
    message: "",
    submitting: false,

    submit() {
      if (this.submitting) {
        return;
      }

      const form = this.$refs.form;

      this.submitting = true;
      this.message = "";

      fetch(form.action, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new URLSearchParams(new FormData(form)),
        signal: AbortSignal.timeout(RESPONSE_TIMEOUT),
      })
        .then(async (response) => {
          const result = await response.json();

          if (response.ok) {
            window.location.href = "?state=succeeded";
            return;
          }

          const errors = Object.values(result.errors ?? {}).flat();
          this.message = errors[0] || result.message || GENERIC_ERROR;
          this.submitting = false;
          this.resetTurnstile();
        })
        .catch(() => {
          this.message = GENERIC_ERROR;
          this.submitting = false;
          this.resetTurnstile();
        });
    },
  };
}
